import request from '@/utils/request'

let Service = {

  /*驾驶员列表*/
  list(data) {
    return request._post('/shop/plus.service.Index/index', data);
},
/*添加驾驶员*/
add(data) {
    return request._post('/shop/plus.service.Index/add', data);
},
/*修改驾驶员*/
edit(data) {
    return request._post('/shop/plus.service.Index/edit', data);
},
/*删除驾驶员*/
del(data) {
    return request._post('/shop/plus.service.Index/del', data);
},
/*驾驶员详情*/
detail(data) {
  return request._post('/shop/plus.service.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.service.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.service.Setting/getSetting', data, errorback);
    },
    // 审核
 passCanel(data) {
    return request._post('/shop/plus.service.Index/passCanel', data);
  },
}
export default Service;



// WEBPACK FOOTER //
// ./src/api/service.js